import { Box, Typography } from "@mui/material";
import { AgeIcon, WeightIcon, HeightIcon, StrongFootIcon } from "../../../assets/icons/MUI/EntitiesIcons";
import EntityOverviewCard from "../../../shared/Entity/EntityOverviewCard";
import { colors } from "../../../theme/palette";
import PlayerPositionLocations from "./PlayerPositionLocations";
import { OverviewCard } from "../../../types";
import { PlayerPositions } from "../../../enums/entity.enum";
import { useTranslation } from "react-i18next";

const iconsMapping: { [key: string]: React.ElementType } = {
  age: AgeIcon,
  weight: WeightIcon,
  height: HeightIcon,
  strongFoot: StrongFootIcon,
};

const PlayerOverview = ({
  cards,
  primaryPosition,
  otherPosition,
  isLoading,
}: {
  cards: OverviewCard[];
  primaryPosition?: PlayerPositions;
  otherPosition?: PlayerPositions;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        padding: "22px 16px",
      }}
    >
      <Typography
        variant="body16Bold"
        sx={{
          display: "block",
          marginBottom: "16px",
          fontWeight: 700,
          color: colors.Black100,
        }}
      >
        {t("pages.entity.playerOverview")}
      </Typography>
      <Box
        sx={{
          paddingBottom: "21px",
          display: "flex",
          gap: "16px",
        }}
      >
        {cards.map((card, index) => {
          const IconComponent = iconsMapping[card.key];
          const isTranslated = card.key === "strongFoot";
          return (
            <EntityOverviewCard
              icon={IconComponent}
              value={card.value}
              title={card.key}
              isTranslated={isTranslated}
              isLoading={isLoading}
            />
          );
        })}
      </Box>
      <Typography
        variant="body16Bold"
        sx={{
          display: "block",
          borderTop: "1px solid #EAECF0",
          paddingTop: "19px",
          marginBottom: "16px",
          fontWeight: 700,
          color: colors.Black100,
        }}
      >
        {t("pages.entity.playerPosition")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "30px",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          alignItems: {
            xs: "flex-start",
            md: "center",
          },
        }}
      >
        <PlayerPositionLocations
          mainPosition={primaryPosition}
          secondaryPosition={otherPosition}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default PlayerOverview;
